import type { GetListResponse } from 'admin';
import { InspectionCompany } from 'api';
import type { yup } from 'form';

export const isCompanyActive = (
  companyData: GetListResponse<InspectionCompany> | undefined
): yup.TestFunction<yup.Maybe<number | null | undefined>, yup.AnyObject> => {
  return (value) => {
    const isInspectionCompanySpecified = Boolean(value);

    if (!isInspectionCompanySpecified) {
      return true;
    }

    const companyObj = companyData?.data.find((company) => company.id === value);

    return Boolean(companyObj?.is_active);
  };
};
